import { TableRow } from '@mui/material';

import { useRouteProperties } from 'features/common/hooks/useRouteProperties';

import { SegmentProperties } from './SegmentProperties';
import { NoSegmentSelected, SegmentWrapper, StyledCell } from './shared-ui';

export default function RouteSegmentInfo() {
  const routeProperties = useRouteProperties();
  if (!routeProperties) return <NoSegmentSelected />;
  const {
    cardinalDirection,
    routeLength,
    freeflowTraveltime,
    routeSelection,
    segment,
    name,
    freeflowSpeed,
  } = routeProperties;
  if (!segment || !routeSelection) return <NoSegmentSelected />;

  return (
    <SegmentWrapper key={routeSelection.id}>
      <SegmentProperties freeflowSpeed={freeflowSpeed} name={name} />
      {cardinalDirection && (
        <TableRow>
          <StyledCell>Direction</StyledCell>
          <StyledCell>{cardinalDirection}</StyledCell>
        </TableRow>
      )}
      {routeLength != null && (
        <TableRow key="route_length">
          <StyledCell>Route Length</StyledCell>
          <StyledCell>{routeLength}</StyledCell>
        </TableRow>
      )}
      {freeflowTraveltime && (
        <TableRow key="freeflow_traveltime">
          <StyledCell>Freeflow traveltime</StyledCell>
          <StyledCell>{freeflowTraveltime}</StyledCell>
        </TableRow>
      )}
    </SegmentWrapper>
  );
}
